import React from 'react'
import { Container } from 'react-bootstrap'
import './Add_Complaint.css'
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from 'moment';
export default function Feedback_Complaint({complaintDetails, setComplaintDetails}) {

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  
    const locate = useLocation();

    useEffect(() => {
          axios
            .post(apiUrl+"get-complaint", {
              id: locate.state?.id,
            })
            .then((res) => {
              setComplaintDetails(res.data.message);
            });
        }, [locate.state?.id]);

 const handleChange = (e) => {
          const { name, value } = e.target;
          setComplaintDetails((prev) => ({
            ...prev,
            feedback: {
              ...prev.feedback,
              [name]: value,
            },
          }));
        };
    const createdDate = complaintDetails.createdDate; // ISO string from backend
const daysAgo = moment().diff(moment(createdDate), 'days');
  
const formatDatecreate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
  return (
    <div>

        <Container>
            <form>
           <div className='plan-details-container-border-complaint mt-5 text-center ms-5'>
  <p  style={{ fontSize:"13px"}}className='mt-3'>
    {/* <span className='text-primary'>Network</span> */}
     Complaint - <span className='text-primary'>{complaintDetails?.complaintType}</span> Customer Affected - <span className='text-primary'>{complaintDetails?.complaintcustomerAffected} @ </span>Location - <span className='text-primary'>{complaintDetails?.complaintlocation}</span></p>                         
   <p style={{ fontSize:"13px"}}  class="mb-3"> Complaint Open Date - <span className='text-primary'>{formatDatecreate(complaintDetails.createdDate)} , </span> Complaint Open Last - <span className='text-primary'>{daysAgo} Days</span></p>                         
   </div>

   <div className='mt-5 mb-4 feedback-installation-container '>
    <label className='ms-5'><strong>Feedback</strong></label>
    <div className='text-center'>
                <textarea
                  type="text"
                  value={complaintDetails?.feedback?.notes}
                   onChange={handleChange}

                  style={{ textTransform: "capitalize", resize: "none",margin:"auto",width:"70%",height:"250px",background:"rgb(222, 250, 241)" }}
                  className=" box address-install"
                  placeholder="Enter Feddback ..."
                  name="notes"
                />

                 {complaintDetails?.feedback?.isCompleted && (
                    <p className='text-center mb-0 me-3 feedback-collectedby-feedback'>collected By <span className='text-primary'>{complaintDetails?.feedback?.updatedBy} </span> At <span className='text-primary'>{complaintDetails?.feedback?.updatedDate}  {complaintDetails?.feedback?.updatedTime}</span></p>
                 )}
        {/* <p className='ms-5 me-5 mt-4' >Our service are very nice and company staffs are vry humble. Especially fiber team is very good</p> */}
        </div>



   </div>
            </form>
        </Container>
    </div>
  )
}
